// extracted by mini-css-extract-plugin
export default {"show_images":"ShowImages_show_images__kiD5u","go_back":"ShowImages_go_back__s8AjF","img_container":"ShowImages_img_container__XMidM"};